import site from '../../data/site.mjs'

const getSiteUrl = () => {
  const dev = process.env.dev === 'true'
  const domain = site.domain
  
  if (dev) return `http://localhost:8888`
  else return `https://www.${domain}`
}

export default getSiteUrl